module.exports = __webpack_public_path__ + "img/up.e2b29baf.svg";